import { createFileRoute } from '@tanstack/react-router';
import { PartnerCheckout } from '~/components/PartnerCheckout/PartnerCheckout';

const PartnerCheckoutComponent = () => {
  const { practitionerId } = Route.useParams();

  return <PartnerCheckout practitioner_id={practitionerId} />;
};

export const Route = createFileRoute(
  '/_public/mayoclinic/store/$practitionerId',
)({
  component: PartnerCheckoutComponent,
});
